export default "__VITE_ASSET__bRE0AdTj__"